var _defs, _path, _path2, _path3, _path4, _path5, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarBoosterSeatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #1c452b;\n      }\n\n      .cls-3 {\n        fill: #e1f4d3;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,96h96V0H0v96ZM33,90c-3.31,0-6-2.69-6-6s2.69-6,6-6,6,2.69,6,6-2.69,6-6,6ZM72,90c-3.31,0-6-2.69-6-6s2.69-6,6-6,6,2.69,6,6-2.69,6-6,6ZM6,28c3.74,0,7.25,1.46,9.9,4.1,2.17,2.17,3.52,4.92,3.94,7.9h32.16v-22c0-1.34.52-2.59,1.46-3.54.94-.94,2.2-1.46,3.54-1.46h3c7.42,0,14.41,2.77,19.8,7.82.03.02.06.06.09.08.21.2.42.39.62.59,5.48,5.48,8.49,12.76,8.49,20.51s-3.02,15.03-8.49,20.51c-5.48,5.48-12.76,8.49-20.51,8.49h-15c-7.75,0-15.03-3.02-20.51-8.49-5.48-5.48-8.49-12.76-8.49-20.51,0-2.67-1.04-5.18-2.93-7.07-1.89-1.89-4.4-2.93-7.07-2.93-1.1,0-2-.9-2-2s.9-2,2-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.99,44H20.08c.47,5.92,3,11.43,7.24,15.68,4.72,4.72,11,7.32,17.68,7.32h15c6.68,0,12.96-2.6,17.68-7.32,4.25-4.25,6.78-9.75,7.24-15.68h-30.91s0,0,0,0c0,0,0,0,0,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57,17c-.26,0-.52.11-.71.29s-.29.44-.29.71v19.84l19.4-15.53c-4.38-3.44-9.75-5.31-15.4-5.31h-3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.38,25.06l-18.68,14.94h25.21c-.44-5.59-2.71-10.8-6.54-14.94Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4,30c0,1.1.9,2,2,2,2.67,0,5.18,1.04,7.07,2.93,1.89,1.89,2.93,4.4,2.93,7.07,0,7.75,3.02,15.03,8.49,20.51,5.48,5.48,12.76,8.49,20.51,8.49h15c7.75,0,15.03-3.02,20.51-8.49,5.48-5.48,8.49-12.76,8.49-20.51s-3.02-15.03-8.49-20.51c-.2-.2-.41-.4-.62-.59-.03-.03-.06-.06-.09-.08-5.39-5.05-12.38-7.82-19.8-7.82h-3c-1.34,0-2.59.52-3.54,1.46-.94.94-1.46,2.2-1.46,3.54v22H19.84c-.42-2.98-1.78-5.73-3.94-7.9-2.64-2.64-6.16-4.1-9.9-4.1-1.1,0-2,.9-2,2ZM56,18c0-.27.1-.52.29-.71s.44-.29.71-.29h3c5.66,0,11.02,1.87,15.4,5.31l-19.4,15.53v-19.84ZM84.91,40h-25.21l18.68-14.94c3.82,4.14,6.1,9.35,6.54,14.94ZM53.99,44s0,0,0,0c0,0,0,0,0,0h30.91c-.47,5.92-3,11.43-7.24,15.68-4.72,4.72-11,7.32-17.68,7.32h-15c-6.68,0-12.96-2.6-17.68-7.32-4.25-4.25-6.78-9.75-7.24-15.68h33.91Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 33,
    cy: 84,
    r: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 72,
    cy: 84,
    r: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarBoosterSeatIcon);
export default __webpack_public_path__ + "static/media/CarBoosterSeatIcon.6932d2b8c9ba7f6cdb775d0a7f87b385.svg";
export { ForwardRef as ReactComponent };